// import { get } from 'lodash';
import * as types from '../actions/actionTypes';
import initialState from './initialState';
import * as storeConstants from '../store/constants';

const dedupeArrayById = (current, updated) => {
  const map = {};
  current.forEach(element => {
    map[element.id] = element;
  });
  updated.forEach(element => {
    map[element.id] = element;
  });
  const deduped = Object.keys(map).map(key => map[key]);
  return deduped;
};

const reducer = (state = initialState[storeConstants.TRYOUT_BADGES], action) => {
  switch (action.type) {
    case types.UPDATE_TRYOUT_BADGES: {
      const newBadges = action.payload;
      if (Array.isArray(newBadges)) {
        const newState = dedupeArrayById(state, newBadges);
        return newState;
      }
      return state; }
    case types.DELETE_TRYOUT_BADGES:
      return [];
    default:
      return state;
  }
};

export default reducer;
